// extracted by css-extract-rspack-plugin
export default {"video":"video-fOt280"};